// extracted by mini-css-extract-plugin
export var banner = "Banner-module--banner--12Nn4";